import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  notification: {
    marginBottom: theme.spacing(3),
  },
  rolesCard: {
    overflow: 'visible',
  },
  header: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  item: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.grey[300],
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    position: 'relative',
  },
  sharedRole: {
    fontWeight: 700,
    fontSize: 'x-small',
    background: '#d0eef4',
    padding: '3px 5px',
    borderRadius: '3px',
  },
  internalRole: {
    fontWeight: 700,
    fontSize: 'x-small',
    background: '#deefd0',
    padding: '3px 5px',
    borderRadius: '3px',
  },
  modalTitle: {
    wordBreak: 'break-word',
    marginRight: theme.spacing(3),
  },
  modalText: {
    color: theme.palette.text.secondary,
    wordBreak: 'break-word',
  },
  checkbox: {
    '& span.MuiCheckbox-root': {
      padding: 0,
      margin: '0 8px 0 12px',
      '&.Mui-focusVisible': {
        outline: '5px auto Highlight !important',
        outlineColor: '-webkit-focus-ring-color !important',
        boxShadow: 'none !important',
        border: 'none !important',
      },
    },
    '& span.MuiFormControlLabel-label': {
      height: 'unset',
      '&.Mui-disabled': {
        color: '#4242424D',
      },
    },
  },
  description: {
    marginTop: '4px',
    color: theme.palette.grey[800],
  },
  disabledDescription: {
    color: '#4242424D',
  },
  submitContainer: {
    display: 'inline-block',
    overflow: 'auto',
  },
}));

export const useModalStyles = makeStyles((theme: Theme) => ({
  modalTitle: {
    wordBreak: 'break-word',
    marginRight: theme.spacing(3),
  },
  modalText: {
    color: theme.palette.text.secondary,
    wordBreak: 'break-word',
  },
  dontSaveButton: {
    border: '1px solid rgba(0, 118, 189, 1)',
  },
  saveButton: {
    '& .MuiButtonBase-root.Mui-focusVisible': {
      boxShadow: '0 0 0 4px rgb(0 125 205 / 30%) !important',
      outline: 'none !important',
    },
  },
}));
